import Vue from "vue";
/**
 * Limit a string to short string.
 * Example: description => desc...
 *
 * @param  {String} str the string to limit
 * @return {String}
 */
Vue.filter("str_limit", function(value, size) {
  if (!value) return "";
  value = value.toString();

  if (value.length <= size) {
    return value;
  }
  return value.substr(0, size) + "...";
});

Vue.filter("toTitle", str => {
  return (
    str &&
    str
      .split(" ")
      .map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1).toLowerCase();
      })
      .join(" ")
  );
});

Vue.filter("snakeToTitle", str => {
  return (
    str &&
    str
      .split("_")
      .map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      })
      .join(" ")
  );
});

Vue.filter("dashToTitle", str => {
  return (
    str &&
    str
      .split("-")
      .map(function(item) {
        return item.charAt(0).toUpperCase() + item.substring(1);
      })
      .join(" ")
  );
});
